<div mat-dialog-content>
  <p>{{ title }}</p>
  <mat-form-field appearance="fill">
    <mat-label>{{ label }}</mat-label>
    <input matInput [(ngModel)]="value" [attr.maxlength]="maxLength">
    <div class="counter">{{ remainingChars }}</div>
  </mat-form-field>
</div>
<div mat-dialog-actions class="dialog-actions">
  <met-button (click)="onNoClick()" buttonText="Abbrechen"></met-button>
  <met-button [mat-dialog-close]="value" buttonText="Speichern"></met-button>
</div>
